// Sugalarm — wake earcon (cycle 100). A short (~180 ms) two-tone blip
// played when the kiosk wakes to its wake word. Distinct from the alarm
// WAVs by design — it's an acknowledgment, not an alert.
//
// Kiosk-only in practice (the only caller gates on variant === "kiosk").
// Reuses a single lazily-created <audio> element.

import { registerCueSource, requestCue } from "./alarmCue";

const EARCON_SRC = "/sounds/wake.wav";

let el: HTMLAudioElement | null = null;

function getEl(): HTMLAudioElement | null {
  if (typeof window === "undefined") return null;
  if (el == null) {
    el = new Audio(EARCON_SRC);
    el.preload = "auto";
    // Cycle 474 (astra round 1, LOW): the earcon is an arbiter source like
    // every other sound, so an alarm or speech starting during its ~180 ms
    // cuts it instead of overlapping. Module-lifetime, like the element.
    const a = el;
    registerCueSource({
      kind: "earcon",
      sounding: () => !a.paused && !a.ended,
      preempt: () => a.pause(),
    });
  }
  return el;
}

/** Play the wake earcon. Best-effort: a rejected play() (autoplay policy
 *  on a surface that never primed audio) is swallowed. */
export function playWakeEarcon(): void {
  const a = getEl();
  if (!a) return;
  // Cycle 474: through the one emit decision like every other sound — the
  // lowest priority, so it never starts over an alarm or speech.
  if (!requestCue("earcon").allow) return;
  try {
    a.currentTime = 0;
  } catch {
    /* ignore */
  }
  void a.play().catch(() => {
    /* autoplay blocked / element busy — non-fatal */
  });
}
